import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Tab Báo Cáo Tuyển Dụng (`reports`)
 * Phân tích hiệu suất phễu chuyển đổi tuyển dụng (Funnel Conversion) và các nguồn tuyển dụng hiệu quả.
 */
export const RecruiterReportsTab: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in text-left">
      <div className="border-b pb-5">
        <h1 className="font-display font-bold text-2xl text-gray-900 leading-tight">Báo cáo tuyển dụng</h1>
        <p className="text-xs text-gray-500 font-medium mt-1">Phân tích hiệu suất, chuyển đổi tuyển dụng và nguồn ứng viên.</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        {/* Khối Bên Trái: Phễu chuyển đổi tuyển dụng */}
        <div className="bg-white rounded-3xl border border-gray-100 p-6 shadow-sm space-y-6">
          <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider">
            Tuyển dụng (Funnel Conversion)
          </h3>

          <div className="space-y-4">
            {[
              { step: 'Tiếp cận ứng viên', count: 250, percent: 100, color: 'bg-orange-400' },
              { step: 'Sàng lọc hồ sơ', count: 156, percent: 62.4, color: 'bg-orange-500' },
              { step: 'Phỏng vấn chuyên môn', count: 89, percent: 35.6, color: 'bg-[#f97316]' },
              { step: 'Đề xuất công việc (Offer)', count: 40, percent: 16.0, color: 'bg-purple-600' },
              { step: 'Tuyển thành công (Hired)', count: 32, percent: 12.8, color: 'bg-green-600' },
            ].map((funnel, i) => (
              <div key={i} className="space-y-1.5 font-semibold text-xs text-gray-700">
                <div className="flex justify-between items-end">
                  <span>{funnel.step}</span>
                  <span className="text-gray-400">{funnel.count} người ({funnel.percent}%)</span>
                </div>
                <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                  <div className={cn("h-full rounded-full transition-all duration-500", funnel.color)} style={{ width: `${funnel.percent}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Khối Bên Phải: Nguồn ứng viên hiệu quả */}
        <div className="bg-white rounded-3xl border border-gray-100 p-6 shadow-sm space-y-6">
          <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider">
            Nguồn tuyển dụng hiệu quả (Sources)
          </h3>

          <div className="space-y-4 text-xs font-semibold text-gray-600">
            {[
              { source: 'Website công ty', count: 68, percent: 43.6, color: '#f97316' },
              { source: 'TopCV', count: 38, percent: 24.4, color: '#10b981' },
              { source: 'VietnamWorks', count: 24, percent: 15.4, color: '#3b82f6' },
              { source: 'LinkedIn', count: 18, percent: 11.5, color: '#8b5cf6' },
              { source: 'Facebook', count: 8, percent: 5.1, color: '#ec4899' },
            ].map((src, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-3.5 h-3.5 rounded-lg shrink-0" style={{ backgroundColor: src.color }} />
                <span className="flex-1 text-gray-700">{src.source}</span>
                <span className="text-gray-400">{src.count} ứng viên</span>
                <span className="font-bold text-gray-800">{src.percent}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruiterReportsTab;
